// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, FreeMode, EffectFade, Controller, Thumbs  } from 'swiper/modules';

function basicSlider(){
	const slider = new Swiper('.basic-slider', {
		modules: [Navigation, Pagination, Autoplay, FreeMode],
		loop: true,
		draggable: true,
		freeMode: {
			enabled: true,
		},
		allowTouchMove: true,
		effect: 'slide',
		spaceBetween: 20,
		slidesPerView: 1,

		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',  // bullets, fraction (ex. 1/10), progressbar
			clickable: true,
		},
		navigation:{
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

		breakpoints: {
			760: {
				slidesPerView: 1,
				spaceBetween: 20
			},
			992: {
				slidesPerView: 1,
				spaceBetween: 20
			},
		},
	});
}


function testimonialSlider(){
	const slider = new Swiper('.testimonial-slider', {
		modules: [Navigation, Pagination, Autoplay, FreeMode],
		loop: true,
		draggable: true,
		freeMode: {
			enabled: false,
		},
		allowTouchMove: true,
		centeredSlides: true,
		effect: 'slide',  
		loopAddBlankSlides: true,
        loopAdditionalSlides: 2,
		spaceBetween: 20,
		slidesPerView: 1.5,		
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',  // bullets, fraction (ex. 1/10), progressbar
			clickable: true,
		},
		navigation:{
			nextEl: '.testimonial-next',
			prevEl: '.testimonial-prev',
		},

		breakpoints: {

			760: {
				slidesPerView: 2.2,
				spaceBetween: 20,
				freeMode: {
					enabled: true,
				},
			},
			992: {
				slidesPerView: 2.5,
				spaceBetween: 20
			},
			1200: {
				slidesPerView: 3.2,
			},
			1440: {
				slidesPerView: 3.5,
			}
		},
	});
}

function newsSlider() {
	const slider = new Swiper('.news-slider', {
		modules: [Navigation, Pagination, Autoplay, EffectFade],
		loop: true,
		draggable: true,
		allowTouchMove: true,		
		effect: 'fade',		
		fadeEffect: {
			crossFade: true
		  },
		slidesPerView: 1,

		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',  // bullets, fraction (ex. 1/10), progressbar
			clickable: true,
		},
		navigation:{
			prevEl: '.news-prev',		
			nextEl: '.news-next',		
		},

		breakpoints: {
			760: {
				slidesPerView: 1,
				spaceBetween: 20
			},
			992: {
				slidesPerView: 1,
				spaceBetween: 20
			},
		},
	});
}
function quoteSlider(){
	const slider = new Swiper('.quote-slider', {
		modules: [Pagination, Autoplay, FreeMode],
		loop: true,
		draggable: true,
		freeMode: {
			enabled: false,
		},
		autoplay: {
			delay: 6000,
		},
		allowTouchMove: true,
		effect: 'slide',
		spaceBetween: 20,
		slidesPerView: 1,		
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',  // bullets, fraction (ex. 1/10), progressbar
			clickable: true,
		},

		breakpoints: {
			760: {
				slidesPerView: 1,
				spaceBetween: 20
			},
			992: {
				slidesPerView: 1,
				spaceBetween: 20
			},
		},
	});
}
function gallerySlider(){
	const slider = new Swiper('.gallery-slider', {
		modules: [Navigation, Autoplay, FreeMode],
		loop: true,
		draggable: true,
		freeMode: {
			enabled: true,
		},
		allowTouchMove: true,
		effect: 'slide',
		spaceBetween: 20,
		slidesPerView: 1.3,
		centeredSlides: false,
		navigation:{
			nextEl: '.gallery-next',		
			prevEl: '.gallery-prev',		
		},

		breakpoints: {
			575: {
				centeredSlides: false,
				slidesPerView: 2,
				spaceBetween: 20
			},
			992: {
				slidesPerView: 3,
				spaceBetween: 20
			},
		},
	});
}
function slideSlider(){
	const slider = new Swiper('.slide-slider', {
		modules: [Navigation, Autoplay, FreeMode],
		loop: false,
		draggable: true,
		freeMode: {
			enabled: false,
		},
		allowTouchMove: true,
		effect: 'slide',
		spaceBetween: 20,
		slidesPerView: 1,
		navigation:{
			nextEl: '.slide-next',		
			prevEl: '.slide-prev',		
		},
		breakpoints: {
			767: {
				slidesPerView: 2.1,
				spaceBetween: 20
			},
			991: {
				slidesPerView: 1.5
			},
			1200: {
				slidesPerView: 2,
				spaceBetween: 20
			},
		},
	});
}
function prepSlider(){
	const slider = new Swiper('[data-target=prep-slider]', {
		modules: [Navigation, Autoplay, EffectFade],
		loop: false,
		draggable: true,
		allowTouchMove: true,		
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		  },
		slidesPerView: 1,
		navigation:{
			nextEl: '.prep-next',		
			prevEl: '.prep-prev',		
		},
		// breakpoints: {
		// 	760: {
		// 		slidesPerView: 2,
		// 		spaceBetween: 20
		// 	},
		// 	992: {
		// 		slidesPerView: 2,
		// 		spaceBetween: 20
		// 	},
		// },
	});
}

function historySlider(){
	const slider = new Swiper('[data-target=history-slider]', {
		modules: [Navigation, Autoplay, FreeMode, Controller, Thumbs],
		loop: false,
		freeMode: {
			enabled: true,
		},
		draggable: true,
		allowTouchMove: true,				
		slidesPerView: 1.25,
		spaceBetween: 20,
		centeredSlides: true,
		navigation:{
			nextEl: '.history-next',		
			prevEl: '.history-prev',		
		},
		breakpoints: {
			768: {
				centeredSlides: false,
				slidesPerView: 2	,
				spaceBetween: 40,		
			},
			991: {
				slidesPerView: 2.5,
				centeredSlides: false,
			},
			1200: {
				slidesPerView: 3.25,
				centeredSlides: false,
			},
		},
	});

	const sliderThumb = new Swiper('[data-target=history-slider-thumbs]', {
		modules: [Navigation, Autoplay, FreeMode, Controller, Thumbs],
		loop: false,
		freeMode: {
			enabled: true,
		},
		draggable: true,
		allowTouchMove: true,				
		slidesPerView: 'auto',
		spaceBetween: 40,
		slideToClickedSlide: true, 
		// navigation:{
		// 	nextEl: '.history-next',		
		// 	prevEl: '.history-prev',		
		// }
	});

	slider.controller.control = sliderThumb;
	sliderThumb.controller.control = slider;

	sliderThumb.slides.forEach((slide, index) => {
		slide.addEventListener('click', () => {
			slider.slideTo(index);
			sliderThumb.slides.forEach((slide, index) => {
				slide.classList.remove('[&.swiper-slide-active]:after:w-full');
				slide.classList.remove('after:w-full');
			});
			slide.classList.add('after:w-full');
		});
	});
}


export { basicSlider, testimonialSlider, newsSlider, quoteSlider, gallerySlider, slideSlider, prepSlider, historySlider };